import { render } from "./GroupFullCard.vue?vue&type=template&id=97fd1bf2&scoped=true"
import script from "./GroupFullCard.vue?vue&type=script&lang=js"
export * from "./GroupFullCard.vue?vue&type=script&lang=js"

import "./GroupFullCard.vue?vue&type=style&index=0&id=97fd1bf2&scoped=true&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97fd1bf2"]])

export default __exports__